<template>
    <div>
      <div class="sub-button-container">
        <button
          v-for="(item, index) in components"
          :key="index"
          :class="{ active: currentComponent === item.component }"
          @click="currentComponent = item.component"
        >
          {{ item.name }}
        </button>
      </div>
      <component :is="currentComponent"></component>
    </div>
  </template>
  
  <script>     
import AdminFeedback from './AdminFeedback.vue';
import ChatManagement from './ChatManagement.vue';
import DeletedChats from './DeletedChats.vue';
import GptManager from './GptManager.vue';
import GptNames from './GptNames.vue';
import KnowledgeDocuments from './KnowledgeDocuments.vue';
  
  export default {
    data() {
      return {
        currentComponent: 'GptManager', 
        components: [ 
          { name: 'Aktif GPTler', component: 'GptNames' }, 
          { name: 'AI Yönetim', component: 'GptManager' }, 
          { name: 'AI Dokümanları Yönetim', component: 'KnowledgeDocuments' },
          { name: 'Sohbet oturumları', component: 'ChatManagement' }, 
          { name: 'Silinen arşiv', component: 'DeletedChats' }, 
          { name: 'Geri Bildirimler', component: 'AdminFeedback' }, 
        ],
      };
    },
    components: {     
      GptManager,
      GptNames,
      KnowledgeDocuments,
      ChatManagement,
      DeletedChats,
      AdminFeedback
    },
  };
  </script>
      